'use strict';

/**
 * @classname ChangeGuideTitle
 * @classdesc ガイドタイトル変更
 */
export default class ChangeGuideTitle {
	/**
	 * @constructor
	 * @param {jQuery} $e - #guide-navigation
	 */
	constructor($e) {
		console.log(`${this.constructor.name}.constructor`);
		this._$e = $e;
		$e.on('change', () => this.onChange());
	};


	/**
	 * changeのコールバック
	 *
	 * @memberof ChangeGuideTitle
	 * @return undefined
	 */
	onChange() {
		console.log(`${this.constructor.name}.onChange`);
		const link = this._$e.val();
		const $target = $(`#${link}`);
		console.log($target);
		const target = $target.offset().top;
		console.log(target);
		$('html, body').animate({scrollTop: target}, 500, 'swing');
	};


	/**
	 * 金額設定
	 *
	 * @memberof ChangeGuideTitle
	 * @return undefined
	 */
	setNewAmount() {
		console.log(`${this.constructor.name}.setPrice`);
		if(this._stockId !== this._controller._itemStockId) return;
		// 小計の更新
		const price = parseInt(this._$e.attr('data-price'));
		const quantity = parseInt(this._$e.val());
		const subtotal = price * quantity;
		this._$e.closest('.block').find('strong').text(Common.separatedByComma(subtotal));
		// 合計の更新
		const res = this._controller._data;
		console.log(res);
		const $area = this._$e.closest('.area--cart');
		$area.find('.total_item_amount').text(`¥${Common.separatedByComma(res.total_item_amount)}`);
		$area.find('.total_tax1').text(`¥${Common.separatedByComma(res.total_tax1)}`);
		$area.find('.total_tax2').text(`¥${Common.separatedByComma(res.total_tax2)}`);
		$area.find('.shipping_fee').text(`¥${Common.separatedByComma(res.shipping_fee)}`);
		$area.find('.total_billing_amount').text(`¥${Common.separatedByComma(res.total_billing_amount)}`);
	};
};
